import { initReactQueryAuth } from 'react-query-auth';

import { Spinner } from '@/components/Elements';
import {
    loginWithEmailAndPassword,
    getUser,
    registerWithEmailAndPassword,
    UserResponse,
    LoginCredentialsDTO,
    RegisterCredentialsDTO,
    AuthUser,
} from '@/features/auth';
import storage from '@/utils/storage';

async function handleUserResponse(data: UserResponse) {
    const { token } = data;
    storage.setToken(token);
    return data;
}

async function loadUser() {
    if (storage.getToken()) {
        const data = await getUser();
        return data;
    }
    return null;
}

async function loginFn(data: LoginCredentialsDTO) {
    const response = await loginWithEmailAndPassword(data);
    const user = await handleUserResponse(response?.data);
    return user;
}

async function registerFn(data: RegisterCredentialsDTO) {
    const response = await registerWithEmailAndPassword(data);
    const user = await handleUserResponse(response);
    return user;
}

async function logoutFn() {
    storage.clearToken();
    window.location.assign('/auth/login');
}

const authConfig = {
    loadUser,
    loginFn,
    registerFn,
    logoutFn,
    LoaderComponent() {
        return (
            <div className="w-screen h-screen flex justify-center items-center">
                <Spinner size="xl" />
            </div>
        );
    },
};

export const { AuthProvider, useAuth } = initReactQueryAuth<
    AuthUser | null,
    unknown,
    LoginCredentialsDTO,
    RegisterCredentialsDTO
>(authConfig);
